import { RouteObject } from 'react-router';
import BaseLayout from 'src/layouts/ExtendedSidebarLayout/BaseLayout';
import ExtendedSidebarLayout from 'src/layouts/ExtendedSidebarLayout';
import accountRoutes from './account';
import baseRoutes from './base';
import configurationRoutes, { Loader } from './configuration';
import dashboardRoutes from './dashboards';
import agentRoutes from './agent';
import clientRoutes from './client';
import receptionRoutes from './reception';
import Configuration from "../components/Authenticated/configuration";
import Reception from "../components/Authenticated/reception";
import Agent from "../components/Authenticated/agent";
import Client from "../components/Authenticated/client";
// import ProviderRoutes from "./provider";
import { lazy } from "react";
import Authenticated from "../components/Authenticated/authenticated";
import { CONTEXT_PATH } from 'src/utils/constant';

const UserProfile = Loader(
    lazy(() => import('src/content/configuration/Users/Single'))
);

const router: RouteObject[] = [
    {
        path: CONTEXT_PATH,
        children: [
            {
                path: 'dashboard',
                element: (
                    <Configuration>
                        <ExtendedSidebarLayout />
                    </Configuration>
                ),
                children: dashboardRoutes
            },
            {
                path: 'configuration',
                element: (
                    <Configuration>
                        <ExtendedSidebarLayout />
                    </Configuration>
                ),
                children: configurationRoutes
            },

            {
                path: 'user',
                element: (
                    <Authenticated>
                        <ExtendedSidebarLayout />
                    </Authenticated>
                ),
                children: [
                    {
                        path: 'profile',
                        element: <UserProfile />
                    }
                ]

            },
            {
                path: 'reception',
                element: (
                    <Reception>
                        <ExtendedSidebarLayout />
                    </Reception>
                ),
                children: receptionRoutes
            },
             {
                path: 'agent',
                element: (
                    <Agent>
                        <ExtendedSidebarLayout />
                    </Agent>
                ),
                children: agentRoutes
            },
             {
                path: 'clients',
                element: (
                    <Client>
                        <ExtendedSidebarLayout />
                    </Client>
                ),
                children: clientRoutes
            },
        ]
    },

    {
        path: 'account',
        children: accountRoutes
    },
    {
        path: '',
        element: (<BaseLayout />),
        children: baseRoutes
    }
];

export default router;
